// extracted by mini-css-extract-plugin
module.exports = {"question":"Question_question__2VXW1","ques":"Question_ques__1fH8M","answer":"Question_answer__2AmY3"};